import { checkHttpStatus, parseJSON, handleError } from '../utils/check-response'
import 'whatwg-fetch'

export default {
	request: function(url, options, data, dispatch, form) {

		let token = localStorage.getItem('token');

		options.headers = {
			'Content-Type': 'application/json'
		};

		options.credentials = 'include';

		if(token != undefined)
		{
			options.headers = Object.assign(options.headers, {
				'Authorization': 'Bearer '+token
			});
		}

		options.headers = Object.assign(options.headers, {
			'Origin': 'http://localhost:8080'
		});

		options.mode = 'cors';

		if(form !== undefined)
			options.beforeSend = form.beforeSend;

		if(options.method != 'GET')
			options.body = JSON.stringify(data);
		
		return fetch(url, options)
			.then(checkHttpStatus)
            .then(parseJSON)
            .catch(function(error){
				handleError(error, dispatch);
            });
	}
}


/** WEBPACK FOOTER **
 ** ./js/services/data.js
 **/